module.exports = __webpack_public_path__ + "img/footer_tablet.293b25eb.svg";